export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-force/src/constant.js
// module id = 178
// module chunks = 0